export default __webpack_public_path__ + "static/media/bgForUi.ba569aea.png";